module.exports = __webpack_public_path__ + "img/28_88.eb3b30d1.png";